/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { useEffect, useState, useCallback } from 'react'
import {
  Grid,
  Typography,
  AccordionSummary,
  Accordion,
  AccordionDetails,
  Chip,
  Modal,
  TextField,
  Box
} from '@material-ui/core';
import { useStyles } from "./styles";
import { useHistory, useParams } from 'react-router-dom';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import Button from '../../components/button';
import { axiosHelperWithToken } from "utils/axios";

import moment from "moment";
import { ImageData } from '../../interfaces/Images';
import { useDispatch } from 'react-redux';
import { showNotification } from 'store/slices/snackbar/snackbarSlice';
import { fetchImages } from 'store/thunks/images';

function CustomerView() {
  const [imageData, setImageData] = useState([] as any);
  const [customerDetails, setCustomerDetails] = useState({
    firstName: '',
    lastName: '',
    email: '',
    dob: '',
    patientCode: '',
    mrn: '',
    invited: false
  });
  const classes = useStyles();
  const axios = axiosHelperWithToken();
  const history = useHistory();
  const dispatch = useDispatch();
  const { id, examId } = useParams() as { id: string, examId: string };
  const [expanded, setExpanded] = useState(Object.keys(imageData)[0]);
  const [selected, setSelected] = useState([] as number[]);
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [showPhoneModal, setShowPhoneModal] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [viewImage, setViewImage] = useState({ images: null, index: -1, image: null }) as any;

  useEffect(() => {
    axios.get(`/Patient/${id}`).then((response) => {
      setCustomerDetails(response.data);
    }).catch(() => {
      dispatch(showNotification({ message: 'An error has occurred', variant: "error" }));
    });

    dispatch(fetchImages(setImageData, setExpanded, id));
  }, [id]);

  const prevNextFunction = (event: any) => {
    if (event.keyCode === 27) {
      // Escape key press
      setViewImage(null);
    }
    else if (event.keyCode === 37) {
      // Left Arrow key press
      setCurrentImage(viewImage?.index - 1);
    }
    else if (event.keyCode === 39) {
      // Right Arrow key press
      setCurrentImage(viewImage?.index + 1);

    }
  };

  const selectOrUnselect = (id: number) => {
    const list = [...selected];
    const index = list.indexOf(id);
    if (index === -1) {
      setSelected([...selected, id]);
    } else {
      setSelected([...list.slice(0, index), ...list.slice(index + 1)]);
    }
  };

  const inviteUser = () => {
    axios.post('/Users/invite-patient', {
      patientId: id,
      email: customerDetails.email
    }).then(() => {
      dispatch(showNotification({ message: 'Invite Sent', variant: "success" }));
      setCustomerDetails({ ...customerDetails, invited: true });
    }).catch(() => {
      dispatch(showNotification({ message: 'An error has occurred', variant: "error" }));
    }).finally(() => {
      setShowInviteModal(false);
    });
  }

  const approveImages = () => {
    axios.put('/Patient/images/approve', selected).then(() => {
      dispatch(showNotification({ message: 'Images Approved', variant: "success" }));
      setSelected([]);
      dispatch(fetchImages(setImageData, setExpanded, id));
    }).catch(() => {
      dispatch(showNotification({ message: 'An error has occurred', variant: "error" }));
    }).finally(() => {
      setShowInviteModal(false);
    });
  }
  const sendImagesOnPhone = () => {
    axios.post(`/Patient/images/sendOnPhone?patientId=${id}&examId=${examId}`).then(() => {
      dispatch(showNotification({ message: 'Images Sent', variant: "success" }));
    }).catch(() => {
      dispatch(showNotification({ message: 'An error has occurred', variant: "error" }));
    }).finally(() => {
    });
  }
  const updatePatientPhoneNumber = () => {
    if (phoneNumber) {
      axios.post(`/Patient/update-patient-phone?patientId=${id}&phoneNumber=${phoneNumber}`).then(() => {
        dispatch(showNotification({ message: 'Phone number Updated', variant: "success" }));
      }).catch(() => {
        dispatch(showNotification({ message: 'An error has occurred', variant: "error" }));
      }).finally(() => {
        setPhoneNumber('');
        setShowPhoneModal(false);
      });
    } else {
      dispatch(showNotification({ message: 'Enter the phone number', variant: "error" }));
    }

  }
  const handleClose = () => {
    setViewImage(null);
  }
  const previousImage = () => {
    setCurrentImage(viewImage?.index - 1);
  }
  const nextImage = () => {
    setCurrentImage(viewImage?.index + 1);
  }
  const setCurrentImage = (index: number) => {
    if (index < viewImage?.images?.length && index > -1) {
      setViewImage({ ...viewImage, index, image: viewImage?.images[index] })
    }
    else {
      setViewImage({ ...viewImage, index: 0, image: viewImage?.images[0] })
    }
  }
  const isVideoMedia = (mediaUri: string) => {
    if (mediaUri) {
      const videoExt = mediaUri.substring(mediaUri.lastIndexOf('.') + 1, mediaUri.length).toLowerCase()
      const isVideo = videoExt === "avi" || videoExt === "mp4"
      return isVideo;
    }
    else return false;
  }
  return (
    <Grid xs={10} item container className={classes.customerInfoWrapper}>
      <Modal
        open={showInviteModal}
        onClose={() => setShowInviteModal(false)}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div className={classes.modalBody}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Customer Email"
            name="email"
            value={customerDetails.email}
            onChange={(e) => { setCustomerDetails({ ...customerDetails, email: e.target.value.trim() }) }}
          />
          <Button
            text={'Invite User'}
            styles={{
              marginRight: '15px',
              display: 'block',
              float: 'right'
            }}
            action={() => {
              inviteUser();
            }} />
        </div>
      </Modal>
      <Modal
        open={showPhoneModal}
        onClose={() => setShowPhoneModal(false)}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div className={classes.modalBody}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="phone"
            label="Phone Number"
            name="phone"
            value={phoneNumber}
            onChange={(e) => { setPhoneNumber(e.target.value.trim()) }}
          />
          <Button
            text={'Update Phone'}
            styles={{
              marginRight: '15px',
              display: 'block',
              float: 'right'
            }}
            action={() => {
              updatePatientPhoneNumber();
            }} />
        </div>
      </Modal>
      <Modal
        open={viewImage?.image}
        onClose={handleClose}
        onKeyDown={prevNextFunction}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div className={classes.modalBody}>
          <div className={classes.imageContainer}>
            <Button action={previousImage} styles={{ padding: '10px' }} text={'<<'}></Button>
            {isVideoMedia(viewImage?.image?.url) ?
              <video width="100%" height="auto" controls >
                <source src={viewImage?.image?.url.toLowerCase().replace(".avi", ".mp4")} type="video/mp4" />
                <track src="" kind="captions" label="english_captions"></track>
              </video> :
              <img src={viewImage?.image?.url} alt={'ultrasound'} width={'100%'} />
            }
            <Button action={nextImage} styles={{ padding: '10px' }} text={'>>'}></Button>
          </div>
        </div>
      </Modal>
      <Grid
        className={classes.backBtn}
        onClick={() => history.push('/clinician-dashboard')}
        item
        xs={10}
      >Back</Grid>
      <div className={classes.examViewHeader}>
        <Typography component="h1" variant="h5" color="inherit" gutterBottom style={{
          color: "black",
          fontSize: "35px",
          lineHeight: "30px",
          width: '100%',
          textAlign: 'center'
        }}>
          {customerDetails.firstName} {customerDetails.lastName}
        </Typography>
        <Typography component="h1" variant="h5" color="inherit" gutterBottom style={{
          color: "black",
          fontSize: "25px",
          lineHeight: "30px",
          width: '100%',
          textAlign: 'center'
        }}>
          {`DOB: ${moment(customerDetails.dob).format('MM/DD/YYYY')}`}
        </Typography>
        <Typography component="h1" variant="h5" color="inherit" gutterBottom style={{
          color: "black",
          fontSize: "25px",
          lineHeight: "30px",
          width: '100%',
          textAlign: 'center'
        }}>
          {`MRN: ${customerDetails.mrn}`}
        </Typography>
      </div>
      <Grid item md={10} sm={12} xs={12} className={classes.galleryContainer}>
        <div className={classes.buttonWrapper}>
          <Box
            component="span"
            m={1}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Button
              text={'Upload Images'}
              styles={{
                marginRight: '15px',
                display: 'block',
                float: 'left'
              }}
              isDisabled={selected.length === 0}
              action={() => {
                approveImages();
              }} />

            <Button version='secondary'
              text={'Send SMS'}
              styles={{
                marginRight: '15px',
                textAlign: 'center',
                display: 'block',
              }}
              action={() => {
                sendImagesOnPhone();
              }} />
            <Button
              text={'Update Phone'}
              styles={{
                marginRight: '15px',
                textAlign: 'center',
                display: 'block',
              }}
              action={() => {
                setShowPhoneModal(true);
              }} />
            {customerDetails.invited ? null :
              <Button
                text={'Invite User'}
                styles={{
                  marginRight: '15px',
                  display: 'block',
                  float: 'right'
                }}
                action={() => {
                  setShowInviteModal(true);
                }} />
            }
          </Box>
        </div>


        {Object.keys(imageData).map((key) => {
          return (
            <Accordion
              key={key}
              expanded={expanded === key}
              onChange={() => setExpanded(key)}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>Images {moment(moment(key, 'MMDDYY')).format('MM/DD/YYYY')}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid item xs={12} container>
                  {imageData[key].map((image: ImageData, index: number) => {
                    return (
                      <Grid
                        xs={12}
                        sm={6}
                        md={4}
                        item
                        className={classes.imageWrapper}
                        key={index}
                      >
                        {isVideoMedia(image.url) ?
                          <video width="100%" height="auto" controls onClick={() => setViewImage({ images: imageData[key], index: index, image })}>
                            <source src={image.url.toLowerCase().replace(".avi", ".mp4")} type="video/mp4" />
                            <track src="" kind="captions" label="english_captions"></track>
                          </video> :
                          <img
                            src={image.url}
                            alt={'ultrasound'}
                            width={'100%'}
                            onClick={() => setViewImage({ images: imageData[key], index: index, image })}
                          />
                        }
                        <div onClick={() => selectOrUnselect(image.mediaId)}>
                          {!image.approved ?
                            (selected.indexOf(image.mediaId) >= 0 ?
                              <CheckCircleOutlineIcon /> : <RadioButtonUncheckedIcon />)
                            : null}
                          {image.approved ? <Chip label={'Uploaded'} /> : null}
                        </div>
                      </Grid>
                    );
                  })}
                </Grid>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Grid>
    </Grid>
  )
}

export default CustomerView
